import { useCallback } from 'react';

import { RootState } from 'store/store';
import { useAppStore } from 'store/store-hooks';
import { useSbPlayerContext } from './sb-player.provider';
import { getPlaybackPlayers } from './sb-player.helper';
import { isNull } from 'components/app/_helpers/_app.helper';

const VAR__Z_FADER = '--z-fader';
const Z_FADER__HIDDEN = -1;
const Z_FADER = 10;

export enum EnumFader {
  on,
  off,
}

export const useSbPlayerCb = () => {
  const { readyToPlay, playerRootElement } = useSbPlayerContext();
  const store = useAppStore();

  const getPlaybackReadyPlayers = useCallback((): Index[] | null => {
    const data = selectData(store.getState());
    const players = getPlaybackPlayers(data).filter((el) => !isNull(el)) as Index[];
    return isPlaybackReady(players, readyToPlay.current) ? players : null;
  }, []);

  const toggleFader = (val: EnumFader) => {
    playerRootElement.current!.style.setProperty(
      VAR__Z_FADER,
      (val === EnumFader.off ? Z_FADER__HIDDEN : Z_FADER) + ''
    );
  };

  return { getPlaybackReadyPlayers, toggleFader };
};

/* S E L E C T O R */

const selectData = (state: RootState) => {
  return state.sb__player;
};

/* H E L P E R */

const isPlaybackReady = (players: Index[], readyToPlay: boolean[]) => {
  return !players.some((i) => !readyToPlay[i]);
};
